import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-detail';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentDetailEffects {

    IncidentDetail$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_DETAIL),
        mergeMap((x: ac.GetIncidentDetailAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentDetail(x.incident_id).pipe(
                map((result: any) => {
                    return new ac.GetIncidentDetailErfolgreichAction(result, x.incident_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentDetailFehlerAction(error, x.incident_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
